module.exports = __webpack_public_path__ + "img/local-15.48f19970.jpg";